<template>
    <div v-if="Role === '1'">
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="5">
                    <h3><span v-if="isAlipay">支付宝小程序</span>租赁规则</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleAdd" v-if="Role === '1'">添加</el-button>
                </el-col>
            </el-row>
        </div>

        <el-table :data="fetchList">
            <el-table-column prop="Q" label="标题">
            </el-table-column>
            <el-table-column prop="A" label="内容">
            </el-table-column>
            <el-table-column inline-template :context="_self" width="200" label="操作" v-if="Role === '1'">
                <span>
                                                                <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
                                                                <el-button @click="handleDelete($index, row)" type="text" size="small">删除</el-button>
                                                    </span>
            </el-table-column>
        </el-table>


        <el-dialog title="编辑租赁规则" :visible.sync="dialogEditVisible" size="large">
            <el-form :model="editForm" ref="editForm" :rules="addStorageRules">
                <el-form-item label="标题" label-width="150px" prop="Q">
                    <el-input v-model="editForm.Q" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="内容" label-width="150px" prop="A">
                    <el-input type="textarea" v-model="editForm.A" auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false">取 消</el-button>
                <el-button type="primary" @click="editRule">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="新建租赁规则" :visible.sync="dialogNewVisible" size="large">
            <el-form :model="newForm" ref="newForm" :rules="addStorageRules">
                <el-form-item label="标题" label-width="150px" prop="Q">
                    <el-input v-model="newForm.Q" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="内容" label-width="150px" prop="A">
                    <el-input type="textarea" v-model="newForm.A" auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogNewVisible = false">取 消</el-button>
                <el-button type="primary" @click="addNewOne">确 定</el-button>
            </div>
        </el-dialog>

    </div>
    <h3 v-else>
        暂无权限
    </h3>
</template>

<script>
    import {
        getRentRule,
        addRentRule
    } from '../../api/version'

    export default {
        data() {
            return {
                 Role: sessionStorage.power,
                fetchList: [],
                cur: '',
                dialogNewVisible: false,
                dialogEditVisible: false,
                addStorageRules: {
                    Q: [{
                        required: true,
                        message: '请填写标题',
                        trigger: 'blur'
                    }],
                    A: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }],

                },
                newForm: {
                    Q: '',
                    A: ''
                },
                editForm: {
                    Q: '',
                    A: ''
                },
            }
        },

        created() {
            this.loadData();
        },
        watch: {
            '$route' () {
                this.loadData();
            }
        },

        computed: {
            isAlipay() {
                return this.$route.path === '/alipayRentRule';
            },
            editId() {
                let id = 7;

                if (this.isAlipay) {
                    id = 53;
                }

                return id;
            }
        },

        methods: {

            loadData() {
                getRentRule(this.editId).then(res => {
                    this.fetchList = res.data.value
                })
            },

            handleDelete(index, row) {
                this.$confirm('此操作将永久删除该规则, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    let data = {value: JSON.parse(JSON.stringify(this.fetchList))}
                    data.value.splice(index,1)


                    addRentRule(this.editId ,sessionStorage.userId, data).then(res => {
                        if (res.data) {
                            this.$message({
                                message: '成功删除',
                                type: 'success'
                            });
                            this.fetchList.splice(index, 1)
                        }
                    }, err => {
                        this.$message.error('删除失败')
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleEdit(index, row) {
                this.dialogEditVisible = true
                this.editForm = JSON.parse(JSON.stringify(row))
                this.cur = index
            },
            editRule() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        let data = { value: JSON.parse(JSON.stringify(this.fetchList))}
                        data.value.splice(this.cur, 1, this.editForm)
                        addRentRule(this.editId, sessionStorage.userId, data).then(res => {
                            console.log(res.data)
                            if (res.data) {
                                this.fetchList[this.cur] = this.editForm
                                this.dialogEditVisible = false
                                this.$message({
                                    message: '成功修改租赁规则',
                                    type: 'success'
                                });
                            }else{
                                this.$message.error('修改失败')
                            }
                        })
                    }
                })
            },
            handleAdd() {
                //添加仓库弹框
                this.dialogNewVisible = true
            },
            addNewOne() {
                //确认添加仓库
                console.log(this.newForm)
                this.$refs['newForm'].validate((valid) => {
                    if (valid) {
                        let data = {
                            value: JSON.parse(JSON.stringify(this.fetchList))
                        }
                        data.value.push(this.newForm)
                        addRentRule(this.editId, sessionStorage.userId, data).then(res => {
                            console.log(res.data)
                            if (res.data) {
                                this.fetchList.push(this.newForm)
                                this.dialogNewVisible = false
                                this.$message({
                                    message: '成功添加租赁规则',
                                    type: 'success'
                                });
                            }else{
                                this.$message.error('添加失败')
                            }
                        })
                    }
                })
            },



        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// RentRule.vue?5ec74e51